import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { notifyExternalNavigation } from "@/lib/runProductTour";

// Montado una sola vez en la raíz de la app (sobrevive a cualquier navegación, a diferencia
// de AdminLayout/EmployeeLayout). Avisa al tour guiado cuando el usuario cambia de ruta por su
// cuenta (sidebar, atrás del navegador, cerrar sesión) mientras un tour está activo, para que
// no se quede un popover apuntando a una pantalla que ya no está.
export function ProductTourRouteGuard() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (prevPath.current !== location.pathname) {
      notifyExternalNavigation(location.pathname);
      prevPath.current = location.pathname;
    }
  }, [location.pathname]);

  return null;
}
